import { render, staticRenderFns } from "./note-detail.vue?vue&type=template&id=01ed0728&"
import script from "./note-detail.vue?vue&type=script&lang=js&"
export * from "./note-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports